import { useSelector } from "react-redux";

import { IMessageScheme } from "../../pages/Chat/type";
import { ReduxState } from "../../types/redux.types";
import useCurrentUser from "../../hooks/useCurrentUser";
import usePrevious from "../../hooks/usePrevious";
import useNotificationSound from "./useNotificationSound";

const useChatNotificationSound = (canGetNotifications = false) => {
  const latestUnreadMessage = useSelector<ReduxState, IMessageScheme | undefined>(
    (state) => state.chat.latestUnreadMessage
  );
  const { user } = useCurrentUser();

  const previousLatestUnreadMessage = usePrevious(latestUnreadMessage);

  const isReceivedMessage = (message: IMessageScheme | undefined): boolean => {
    return !!(message && (message.senderRef ? message.senderRef.id === user.id : message.senderRef === null));
  };

  const isFirstMessage = isReceivedMessage(latestUnreadMessage) && !previousLatestUnreadMessage;

  const isLaterMessage = !!(
    latestUnreadMessage &&
    previousLatestUnreadMessage &&
    isReceivedMessage(latestUnreadMessage) &&
    isReceivedMessage(previousLatestUnreadMessage) &&
    latestUnreadMessage.text !== previousLatestUnreadMessage.text
  );

  useNotificationSound(canGetNotifications && (isFirstMessage || isLaterMessage), "New Chat Message", [
    latestUnreadMessage,
  ]);
};

export default useChatNotificationSound;
